import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Theme from "./Theme/index";
import Login from './component/LoginLogout/login';
import Signup from './component/LoginLogout/signup';
import ChangePassword from './component/LoginLogout/changePassword';
import ForgotPassword from './component/LoginLogout/forgotPassword';
import ActivatePage from './component/LoginLogout/activatePage';

function App() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const checkAuthStatus = () => {
      const storedToken = sessionStorage.getItem("tokenId");
      const expiry = sessionStorage.getItem("expiryId");

      if (storedToken && expiry) {
        const currentTime = Date.now();

        if (currentTime < parseInt(expiry, 10)) {
          setToken(storedToken);
        } else {
          sessionStorage.clear();
          setToken(null);
        }
      } else {
        setToken(null);
      }
    };

    checkAuthStatus();
    const interval = setInterval(checkAuthStatus, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <Routes>
        {/* {token ? ( */}
          <>
            <Route path="/" element={<Theme />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/activate" element={<ActivatePage />} />
          </>
        {/* ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/activate" element={<ActivatePage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )} */}
      </Routes>
    </Router>
  );
}

export default App;
